import { useMemo } from 'react';
import useGlobal from 'global-state/store';
import { adminPermissions } from 'utils/inventoryRoles';

export default function useAdminPermissions() {
  const [globalState] = useGlobal();
  return useMemo(() => adminPermissions(globalState.roles), [globalState.roles]);
}
